<template>
  <v-dialog v-if="orderModal" v-model="showInfo" max-width="581">
    <v-card>
      <v-card-title>
        <div class="display-1">BESTÄLL INFO</div>
      </v-card-title>

      <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>

      <v-card-text class="mt-n7">
        <div v-if="orderModal">
          <div>
            <div class="overline">Process</div>
            <div class="body-1">{{ orderModal.process }}</div>
          </div>
          <div>
            <div class="overline">Steg</div>
            <div class="body-1">{{ orderModal.status }}</div>
          </div>
          <div>
            <div class="overline">VAD SOM HAR HÄNT</div>
            <div class="body-1">{{ orderModal.motive }}</div>
          </div>
          <div>
            <div class="overline">VEM SOM AGERAT</div>
            <div class="body-1">
              {{ getName(orderModal.actor).label }}
            </div>
          </div>
          <div>
            <div class="overline">VAD SOM HÄNDER NÄST</div>
            <div class="body-1">{{ orderModal.next }}</div>
          </div>
          <div>
            <div class="overline">VEM HAR BOLLEN</div>
            <div class="body-1 mb-n4">
              {{ getName(orderModal.dependsOn).label }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {ORDER_TEXTS} from '@/lib/status-texts.js'

export default {
  name: 'OrderInfoModal',

  components: {},

  props: {
    showInfo: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      required: true
    }
  },

  data: () => ({}),

  created() {},

  computed: {
    orderModal() {
      return ORDER_TEXTS[this.order.state]
    }
  },

  watch: {},

  methods: {
    getName(type) {
      let label

      switch (type) {
        case 'BYN {regionär2}':
          label = 'BYN'
          break
        case 'Företaget':
          label = this.order.companyName
          break
        case 'Kanslist':
          label = `Kanslist`
          break
        default:
          label = type
      }
      return {
        label: label || type
      }
    }
  }
}
</script>

<style>
</style>